import onHold from "apis/onHold";
import { addCaseNote } from "requests/homeowner/caseforms";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "../../tools/webservice";
import { CASE_NOTE_TYPE_GENERAL } from "typeConstants/caseNoteTypes";

export const getHoldReasons = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: onHold.holdReasons(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const putOnHold = (controlIdNumbers, internetUser, endDate, onHoldNote, successCallback, errorCallback, mountedRef) => {
  if (!Array.isArray(controlIdNumbers)) controlIdNumbers = [controlIdNumbers];

  return WebApiRequest({
    method: HTTP_POST,
    payload: controlIdNumbers.map(c => ({
      ControlIdNumber: c,
      InternetUserId: internetUser,
      EndDate: endDate,
      Note: onHoldNote
    })),
    endpoint: onHold.onHold(),
    successCallback,
    errorCallback,
    mountedRef
  });
};

export const putOffHold = (controlIdNumbers, internetUser, successCallback, errorCallback, mountedRef) => {
  if (!Array.isArray(controlIdNumbers)) controlIdNumbers = [controlIdNumbers];

  return WebApiRequest({
    method: HTTP_POST,
    payload: controlIdNumbers.map(c => ({
      ControlIdNumber: c,
      InternetUserId: internetUser,
    })),
    endpoint: onHold.offHold(),
    successCallback,
    errorCallback,
    mountedRef
  });
};

export const sendMessage = (controlIdNumber, note, successCallback, errorCallback, mountedRef) => {
  addCaseNote(controlIdNumber, 
    CASE_NOTE_TYPE_GENERAL, 
    {
      NoteBody: note
    },
    successCallback,
    errorCallback,
    mountedRef);
};